import {
  FileIcon,
  FileTextIcon,
  LayoutIcon,
  PenNibIcon,
  PencilSimpleIcon,
  TrashIcon,
} from '@phosphor-icons/react';
import { css, html } from 'react-strict-dom';
import { color } from 'src/constants/color.css';

import { Api } from '../../../api';
import { IconButton, Text } from '../../../components';
import { Color, Style } from '../../../constants';

type Props = {
  resource: Api.DesignResource.V;
  canManage: boolean;
  onEdit: () => void;
  onDelete: () => void;
};

function categoryIcon(category: string | null) {
  switch (category) {
    case 'Design Files':
      return PenNibIcon;
    case 'Design Documents':
      return FileTextIcon;
    case 'UI Kit':
      return LayoutIcon;
    default:
      return FileIcon;
  }
}

export default function ResourceCard({
  resource,
  canManage,
  onEdit,
  onDelete,
}: Props) {
  const PlaceholderIcon = categoryIcon(resource.category);

  return (
    <html.div style={styles.card}>
      <html.a
        href={resource.link}
        target="_blank"
        rel="noopener noreferrer"
        style={styles.contentLink}
      >
        <html.div style={[styles.iconBadge, Style.centerBoth]}>
          <PlaceholderIcon size={18} color={Color.neutral80} />
        </html.div>
        <Text typeface="headline" color="neutral100" as="h3">
          {resource.title}
        </Text>
      </html.a>
      {canManage && (
        <html.div style={[Style.row, Style.alignCenter, styles.actions]}>
          <IconButton aria-label="Delete" onClick={onDelete}>
            <TrashIcon size={20} color={Color.neutral80} />
          </IconButton>
          <IconButton aria-label="Edit" onClick={onEdit}>
            <PencilSimpleIcon size={20} color={Color.neutral100} />
          </IconButton>
        </html.div>
      )}
    </html.div>
  );
}

const styles = css.create({
  card: {
    position: 'relative',
    backgroundColor: color.neutral0,
    borderRadius: 8,
    padding: 24,
    boxShadow: '0px 16px 16px 0px rgba(0,0,0,0.04)',
  },
  contentLink: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    textDecorationLine: 'none',
  },
  iconBadge: {
    display: 'flex',
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: color.neutral10,
  },
  actions: {
    position: 'absolute',
    top: 14,
    right: 14,
  },
});
